// extracted by mini-css-extract-plugin
export default {"container":"modal_container__P73pc","header_container":"modal_header_container__OLHXU","header_title":"modal_header_title__BHGYh","header_sub_title":"modal_header_sub_title__zaVpz"};